import React from 'react';
import { AudioLines } from 'lucide-react';
import AudioConverter from '../components/AudioConverter';
import { useTranslation } from 'react-i18next';
import { SEO, SITE_URL, breadcrumbJsonLd } from '../components/SEO';

const AudioConverterPage: React.FC = () => {
  const { t } = useTranslation();
  const description = 'Extract audio from video or convert audio files to MP3, WAV, and OGG in your browser before transcription. No media upload required.';

  return (
    <section className="py-16 bg-slate-50/60 dark:bg-zinc-900/40 min-h-[calc(100vh-4rem)] transition-colors duration-300">
      <SEO
        title="Free Audio Converter - Extract Audio from Video | OmniScribe"
        description={description}
        path="/tools/audio-converter"
        keywords={[
          'audio converter',
          'video to audio converter',
          'extract audio from video',
          'convert audio to MP3',
          'WAV converter',
          'OGG converter',
        ]}
        jsonLd={[
          breadcrumbJsonLd([
            { name: 'Home', path: '/' },
            { name: 'Audio Converter', path: '/tools/audio-converter' },
          ]),
          {
            '@context': 'https://schema.org',
            '@type': 'WebApplication',
            name: 'OmniScribe Audio Converter',
            url: `${SITE_URL}/tools/audio-converter`,
            applicationCategory: 'MultimediaApplication',
            operatingSystem: 'Web',
            description,
            offers: {
              '@type': 'Offer',
              price: '0',
              priceCurrency: 'USD',
            },
          },
        ]}
      />
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/80 dark:bg-zinc-900/70 backdrop-blur-sm text-indigo-700 text-sm font-medium mb-6 border border-indigo-100 dark:text-indigo-300 dark:border-indigo-500/20 shadow-sm">
            <AudioLines className="h-4 w-4" />
            {t('tools.badge')}
          </div>
          <h1 className="h-section mb-4">{t('tools.audioConverter.title')}</h1>
          <p className="text-slate-600 dark:text-zinc-400 leading-relaxed">
            {t('tools.audioConverter.descriptionLine1')} <br />
            {t('tools.audioConverter.descriptionLine2')}
          </p>
        </div>

        <AudioConverter />
      </div>
    </section>
  );
};

export default AudioConverterPage;
